import { formatPrice } from "src/utils/format-price";

export const dedaultBudgetOptions = [
  { name: formatPrice(10000), value: 10000 },
  { name: formatPrice(15000), value: 15000 },
  { name: formatPrice(20000), value: 20000 },
  { name: formatPrice(25000), value: 25000 },
  { name: formatPrice(30000), value: 30000 },
  { name: formatPrice(35000), value: 35000 },
  { name: formatPrice(40000), value: 40000 },
  { name: formatPrice(45000), value: 45000 },
  { name: formatPrice(50000), value: 50000 },
  { name: formatPrice(60000), value: 60000 },
  { name: formatPrice(70000), value: 70000 },
  { name: formatPrice(80000), value: 80000 },
  { name: formatPrice(90000), value: 90000 },
  { name: formatPrice(100000), value: 100000 },
  { name: formatPrice(125000), value: 125000 },
  { name: formatPrice(150000), value: 150000 },
  { name: formatPrice(200000), value: 200000 },
];
